import type {Settings} from "./typing";
import {setPreferences} from "./preferences";
import {setOptions} from "./options";

export type { Settings, SettingsNavigationProperty, SettingsOptions, SettingsPreferences, SettingsPathsProperty } from './typing'
export { preferences } from './preferences'
export { options } from './options'

export default function configureSettings(params: Settings) {
    setOptions({ navigation: params.navigation, presets: params.presets, localization: params.localization});
    setPreferences({ name: params.name, email: params.email, domain: params.domain, presets: params.presets })
}